import {Dispatch, SetStateAction} from 'react';
import {chakra, VStack, Heading} from '@chakra-ui/react';
import {IMAGE_PREFIX} from '../env';
import Agreement from '../components/Agreement';

const BG_HEIGHT = 140;

type Props = {
  linkTargetId: string,
  isAgreedWith: boolean,
  setIsAgreedWith: Dispatch<SetStateAction<boolean>>
};

export default function Title({
  linkTargetId,
  isAgreedWith,
  setIsAgreedWith
}: Props) {
  return (
    <chakra.section
      mt={[`${44/16}rem`, `${44/16}rem`, `${67/16}rem`]}
      pt={[`${(BG_HEIGHT/2 + 20)/16}rem`, `${(BG_HEIGHT/2 + 20)/16}rem`, `${(BG_HEIGHT + 40)/16}rem`]}
      bgImage={`${IMAGE_PREFIX}img-graph-01.png`}
      bgSize={[`auto ${BG_HEIGHT/2/16}rem`, `auto ${BG_HEIGHT/2/16}rem`, `auto ${BG_HEIGHT/16}rem`]}
      bgPosition="top center"
      bgRepeat="no-repeat"
      textAlign="center"
    >
      <VStack spacing={`${42/16}rem`}>
        <Heading as="h1" className="marker-yellow" letterSpacing="0.2em">
          円グラフで知る
          <chakra.br display={['inline', 'inline', 'none']} />
          <chakra.span
            fontFamily="inherit"
            fontWeight="inherit"
            color="blue.500"
          >“わたしの分人”</chakra.span>
        </Heading>
        <Agreement linkTargetId={linkTargetId} isAgreedWith={isAgreedWith} setIsAgreedWith={setIsAgreedWith} />
      </VStack>
    </chakra.section>
  );
}
